import { Typography } from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';

export const WarningMessage = ({ children }: PropsWithChildren) => (
  <Typography color="error" mt={12} variant="body">
    {children}
  </Typography>
);
